import React from 'react';
import Icon from 'components/AppIcon';

export default function VersionHistoryDrawer({ doc, onClose, onToast }) {
  if (!doc) return null;

  const handleRestore = (version) => {
    onToast({ type: 'success', title: 'Version restored', message: `${doc?.name} restored to ${version?.version}.` });
  };

  const handleDownloadVersion = (version) => {
    onToast({ type: 'info', title: 'Downloading', message: `Downloading ${doc?.name} ${version?.version}…` });
  };

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0"
        style={{ zIndex: 'var(--z-modal, 1000)', background: 'rgba(0,0,0,0.3)' }}
        onClick={onClose}
      />
      {/* Drawer */}
      <div
        className="fixed top-0 right-0 h-full w-96 bg-card border-l border-border shadow-2xl flex flex-col"
        style={{ zIndex: 'calc(var(--z-modal, 1000) + 1)' }}
      >
        {/* Header */}
        <div className="flex items-center gap-3 px-5 py-4 border-b border-border flex-shrink-0">
          <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-primary/10">
            <Icon name="History" size={16} color="var(--color-primary)" />
          </div>
          <div className="flex-1 min-w-0">
            <h2 className="font-heading text-sm font-semibold text-foreground">Version History</h2>
            <p className="text-xs font-caption text-muted-foreground truncate">{doc?.name}</p>
          </div>
          <button
            onClick={onClose}
            className="flex items-center justify-center w-8 h-8 rounded-lg text-muted-foreground hover:text-foreground hover:bg-muted transition-all duration-200"
          >
            <Icon name="X" size={16} />
          </button>
        </div>

        {/* Version List */}
        <div className="flex-1 overflow-y-auto p-4 space-y-3">
          {doc?.versions?.map((v, idx) => (
            <div
              key={v?.version}
              className={`rounded-xl border p-4 ${
                idx === 0
                  ? 'border-primary/30 bg-primary/5' :'border-border bg-background'
              }`}
            >
              <div className="flex items-start justify-between gap-2 mb-2">
                <div className="flex items-center gap-2">
                  <span
                    className={`text-xs font-semibold px-2 py-0.5 rounded-full font-caption ${
                      idx === 0
                        ? 'bg-primary/20 text-primary' :'bg-muted text-muted-foreground'
                    }`}
                  >
                    {v?.version}
                  </span>
                  {idx === 0 && (
                    <span className="text-xs font-caption text-primary font-semibold">Current</span>
                  )}
                </div>
                <span className="text-xs font-caption text-muted-foreground flex-shrink-0">{v?.size}</span>
              </div>

              <div className="space-y-1 mb-3">
                <div className="flex items-center gap-1.5 text-xs font-caption text-muted-foreground">
                  <Icon name="Calendar" size={11} />
                  <span>{v?.date}</span>
                </div>
                <div className="flex items-center gap-1.5 text-xs font-caption text-muted-foreground">
                  <Icon name="User" size={11} />
                  <span>{v?.uploadedBy}</span>
                </div>
              </div>

              <p className="text-xs font-caption text-foreground mb-3 leading-relaxed">
                {v?.changeNote}
              </p>

              <div className="flex items-center gap-2">
                <button
                  onClick={() => handleDownloadVersion(v)}
                  className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-md text-xs font-caption font-medium text-muted-foreground hover:text-primary hover:bg-primary/10 border border-border transition-all duration-200"
                >
                  <Icon name="Download" size={12} /> Download
                </button>
                {idx !== 0 && (
                  <button
                    onClick={() => handleRestore(v)}
                    className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-md text-xs font-caption font-medium text-amber-700 hover:bg-amber-50 border border-amber-200 transition-all duration-200"
                  >
                    <Icon name="RotateCcw" size={12} /> Restore
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
